import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getCookieConsent, subscribeCookieConsent } from '../lib/cookieConsent';

/**
 * Floating CTAs sit under the cookie notice (z-60 vs z-50).
 * On a phone, taps on "Message us" hit Accept all instead of /contact.
 * Hide them until consent, and on /contact where they cover the form.
 * `/preview/photos` has no cookie banner, so show the button there immediately.
 */
export function usePublicFloatingCtaVisible() {
  const location = useLocation();
  const [cookiesChosen, setCookiesChosen] = useState(() => getCookieConsent() !== null);

  useEffect(() => subscribeCookieConsent(() => setCookiesChosen(true)), []);

  const onContact = location.pathname === '/contact';
  const onCakeRequest = location.pathname.startsWith('/cake-request');
  const onAdmin = location.pathname.startsWith('/admin');
  const onPreview = location.pathname.startsWith('/preview');
  return (cookiesChosen || onPreview) && !onContact && !onCakeRequest && !onAdmin;
}
